export const SIGN_OUT = 'SIGN_OUT';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_PROFILE = 'SET_PROFILE';
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';

const initialState = {
  user: {},
  accessToken: '',
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_TOKEN:
      return {
        ...state,
        accessToken: action.payload.data,
      };

    case SET_PROFILE:
      return {
        ...state,
        user: action.payload.data,
      };

    case FORGOT_PASSWORD:
      return {
        ...initialState,
      };

    case SIGN_OUT:
      return {
        ...initialState,
      };

    default:
      return state;
  }
}
